import React from "react";

export default ({ label, required, children, error, ...modifiers }) => {
  let className = `radioGroup ${error ? "-error" : ""}`;
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  return (
    <div className={className}>
      <div className="radioGroup_label">
        {label} {required && <span className="radioGroup_required">*</span>}
      </div>
      <div className="radioGroup_choices">{children}</div>
    </div>
  );
};
